// A rejected write is never queued or replayed. The person retries after the pause.
export function retryAfterMs(value, now = Date.now()) {
    if (value != null && String(value).trim() !== '') {
        const seconds = Number(value);
        if (Number.isFinite(seconds) && seconds >= 0) return seconds * 1000;
        const date = Date.parse(value);
        if (Number.isFinite(date)) return Math.max(0, date - now);
    }
    return 60_000;
}

export function shouldRetryQuery(count, error) {
    return count < 1 && (error?.isNetwork || error?.isTimeout || error?.status >= 500);
}

export function rateLimitMessage(ms) {
    return `Demasiadas solicitudes. Espera ${Math.max(1, Math.ceil(ms / 1000))} segundos y vuelve a intentarlo. Tu formulario se conserva.`;
}

export function createCooldown(now = Date.now) {
    let until = 0;
    return {
        remaining: () => Math.max(0, until - now()),
        pause: ms => { until = Math.max(until, now() + ms); },
    };
}
